import accountsAPI from "../../../../services/accounts";
import { Avatar } from "primereact/avatar";
import { Tag } from "primereact/tag";
import { DataView } from "primereact/dataview";
import { Skeleton } from "primereact/skeleton";
import MeaLink from "../../../../components/MeaLink";

const UserSchoolsListComponent = () => {
  const accessToken = "";

  const membershipsList = accountsAPI.useMemberships(
    accessToken,
    "1",
    "1000000"
  );
  const isMembershipsLoading =
    membershipsList?.isLoading || membershipsList?.status === "loading";
  const memberships = (membershipsList?.data?.data || []).filter(
    (membership) => membership?.school?.status === "ACTIVE"
  );
  const loadingPlaceholders = Array.from({ length: 6 }, (_, index) => ({
    id: `loading-${index}`,
  }));

  const getSeverity = (status) => {
    switch (status) {
      case "is_owner":
        return "success";

      case "is_admin":
        return "warning";

      case "is_staff":
        return "danger";

      case "is_teacher":
        return "danger";

      case "is_parent":
        return "danger";

      case "is_student":
        return "danger";

      default:
        return null;
    }
  };

  const getMembershipRoles = (membership) => {
    return [
      membership.is_owner && { key: "is_owner", label: "Propri\u00e9taire" },
      membership.is_admin && { key: "is_admin", label: "Administration" },
      membership.is_staff && { key: "is_staff", label: "Personnel" },
      membership.is_teacher && { key: "is_teacher", label: "Enseignant" },
      membership.is_parent && { key: "is_parent", label: "Parent" },
      membership.is_student && { key: "is_student", label: "Etudiant" },
    ].filter(Boolean);
  };

  const getInitials = (membership) => {
    const schoolName = membership?.school?.name || "?";

    return schoolName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("");
  };

  const itemTemplate = (membership) => {
    const roles = getMembershipRoles(membership);
    const schoolAvatar = membership?.school?.avatar;

    return (
      <div className="col-12 md:col-6 xl:col-4 p-4" key={membership.id}>
        <MeaLink
          to={`/school/${membership.school_id}`}
          className="w-full no-underline"
        >
          <div className="h-full shadow-2 border-round-xl overflow-hidden surface-card">
            <div className="flex flex-column md:flex-row h-full">
              <div
                className="flex align-items-center justify-content-center surface-100 border-right-1 surface-border"
                style={{ minWidth: "12rem", width: "12rem" }}
              >
                {schoolAvatar ? (
                  <img
                    src={schoolAvatar}
                    alt={membership?.school?.name || "Ecole"}
                    className="block w-full h-full"
                    style={{ objectFit: "cover", minHeight: "100%" }}
                  />
                ) : (
                  <Avatar
                    label={getInitials(membership)}
                    shape="circle"
                    size="xlarge"
                  />
                )}
              </div>

              <div className="flex flex-column gap-4 h-full flex-1 py-4 px-5">
                <div className="flex align-items-start justify-content-between gap-3">
                  <div className="min-w-0">
                    <div className="text-xl font-semibold text-900 line-height-3">
                      {membership?.school?.name || "Ecole sans nom"}
                    </div>
                    
                  </div>
                </div>

                <div className="text-700 line-height-3 min-h-5rem">
                  {membership?.school?.presentation ||
                    "Aucune pr\u00e9sentation disponible pour cette \u00e9cole."}
                </div>

                

                <div className="flex align-items-center justify-content-between mt-auto pt-2 border-top-1 surface-border">
                  <div className="flex flex-wrap gap-2">
                  {roles.map((role) => (
                    <Tag
                      key={`${membership.id}-${role.key}`}
                      value={role.label}
                      severity={getSeverity(role.key)}
                    />
                  ))}
                </div>
                  <span className="text-primary font-medium flex align-items-center gap-2">
                    Ouvrir
                    <i className="pi pi-arrow-right text-sm"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </MeaLink>
      </div>
    );
  };

  const loadingItemTemplate = (placeholder) => {
    return (
      <div className="col-12 md:col-6 xl:col-4 p-4" key={placeholder.id}>
        <div className="h-full shadow-2 border-round-xl overflow-hidden surface-card">
          <div className="flex flex-column md:flex-row h-full">
            <div
              className="flex align-items-center justify-content-center surface-100 border-right-1 surface-border"
              style={{ minWidth: "12rem", width: "12rem", minHeight: "12rem" }}
            >
              <Skeleton shape="circle" size="5rem" />
            </div>

            <div className="flex flex-column gap-4 h-full flex-1 py-4 px-5">
              <Skeleton width="60%" height="1.75rem" />
              <div className="flex flex-column gap-2 min-h-5rem">
                <Skeleton width="100%" height="1rem" />
                <Skeleton width="100%" height="1rem" />
                <Skeleton width="70%" height="1rem" />
              </div>

              <div className="flex align-items-center justify-content-between mt-auto pt-2 border-top-1 surface-border">
                <div className="flex flex-wrap gap-2">
                  <Skeleton width="6rem" height="2rem" borderRadius="16px" />
                  <Skeleton width="6rem" height="2rem" borderRadius="16px" />
                </div>
                <Skeleton width="4rem" height="1rem" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DataView
      value={isMembershipsLoading ? loadingPlaceholders : memberships}
      itemTemplate={isMembershipsLoading ? loadingItemTemplate : itemTemplate}
      emptyMessage={isMembershipsLoading ? "" : "Vous n'appartenez à aucune école."}
      layout="grid"
      pt={{
        content: {
          style: {
            background: "transparent",
            border: "none",
            padding: 0,
          },
        },
      }}
    />
  );
};

export default UserSchoolsListComponent;
